export const makeApiRequest = () => {
	document.querySelector('.pricing-calculator__loading-overlay').style.display = 'flex';
	const activeToggle = document.querySelector('.pricing-calculator__toggle--active');
	let term = '';
	if (activeToggle) {
		term = activeToggle.getAttribute('data-term');
	}

	const ultimateSeatsInput = document.querySelector('#ultimate-input-number');
	const coreSeatsInput = document.querySelector('#core-input-number');

	let ultimateSeats = 0;
	if (ultimateSeatsInput) {
		ultimateSeats = ultimateSeatsInput.value;
	}
	let coreSeats = 0;
	if (coreSeatsInput) {
		coreSeats = coreSeatsInput.value;
	}

	const apiUrl = `https://api.optery.com/api/landingpage/business/price?term=${term}&ultimate_seats=${ultimateSeats}&core_seats=${coreSeats}`;

	fetch(apiUrl)
		.then((response) => {
			if (!response.ok) {
				throw new Error(`API request failed with status: ${response.status}`);
			}
			return response.json();
		})
		.then((data) => {
			// Handle the API response data here
			parseAndDisplayData(data);
			// You can update your block's UI or do whatever you need with the data
		})
		.catch((error) => {
			// Handle any errors that occurred during the fetch
			console.error('API request error:', error);
		});
}

const setEmptyValues = (planName) => {
	document.querySelector(`.pricing-calculator__user-amount[data-plan="${planName}"]`).textContent = 0;
	const planPricesPerUser = document.querySelectorAll(`.pricing-calculator__price[data-plan="${planName}"]`);
	if (planPricesPerUser) {
		planPricesPerUser.forEach(element => {
			element.innerHTML = '<strong>$0</strong>' + '/user';
		});
	}
	document.querySelector(`.pricing-calculator__breakdown-value[data-plan="${planName}"]`).textContent = `$0.00`;
}

const parseAndDisplayData = (data) => {
// Extract relevant data from the API response
	const totalVolumeDiscount = data.pricing.total_volume_discount;
	const totalOriginalPrice = data.pricing.total_original_price;
	const subtotal = data.pricing.subtotal;
	const items = data.pricing.items;

	document.querySelector('.pricing-calculator__price-value').textContent = `$${totalOriginalPrice.toFixed(2)}`;
	document.querySelector('.pricing-calculator__savings-value').textContent = `$${totalVolumeDiscount.toFixed(2)}`;
	document.querySelector('.pricing-calculator__price-final').textContent = subtotal.toFixed(2);

	setEmptyValues('core');
	setEmptyValues('ultimate');
	if (items && items.length > 0) {
		items.forEach((item) => {
			if (item.name.toLowerCase() === 'core') {
				document.querySelector('.pricing-calculator__user-amount[data-plan="core"]').textContent = item.quantity;
				const planPricesPerUser = document.querySelectorAll('.pricing-calculator__price[data-plan="core"]');
				if (planPricesPerUser) {
					planPricesPerUser.forEach(element => {
						element.innerHTML = '<strong>$' + (item.original_unit_price - (item.original_unit_price * item.discount_percent / 100)).toFixed(2) + '</strong>' + '/user';
					});
				}
				document.querySelector('.pricing-calculator__breakdown-value[data-plan="core"]').textContent = `$${item.total}`;
			} else if (item.name.toLowerCase() === 'ultimate') {
				document.querySelector('.pricing-calculator__user-amount[data-plan="ultimate"]').textContent = item.quantity;
				const planPricesPerUser = document.querySelectorAll('.pricing-calculator__price[data-plan="ultimate"]');
				if (planPricesPerUser) {
					planPricesPerUser.forEach(element => {
						element.innerHTML = '<strong>$' + (item.original_unit_price - (item.original_unit_price * item.discount_percent / 100)).toFixed(2) + '</strong>' + '/user';
					});
				}
				document.querySelector('.pricing-calculator__breakdown-value[data-plan="ultimate"]').textContent = `$${item.total}`;
			}
		});
	}

	document.querySelector('.pricing-calculator__loading-overlay').style.display = 'none';

	/*console.log('Total Volume Discount:', totalVolumeDiscount);
	console.log('Total Original Price:', totalOriginalPrice);
	console.log('Subtotal:', subtotal);
	console.log('Items:', items);*/
}

